// extracted by mini-css-extract-plugin
export default {"segment-desc-wrapper":"segment-desc-wrapper_Bcoua"};